import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export interface AppTelemetry {
  reactPlugin: ReactPlugin;
  appInsights: ApplicationInsights;
}

let cached: AppTelemetry | null = null;

export function initAppInsights(
  connectionString: string | undefined
): AppTelemetry | null {
  if (cached) return cached;

  if (!connectionString) {
    if ((import.meta.env as { DEV?: boolean }).DEV) {
      console.warn(
        '[telemetry] VITE_APPINSIGHTS_CONNECTION_STRING is not set; Application Insights is disabled.'
      );
    }
    return null;
  }

  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: false,
      autoTrackPageVisitTime: true,
      disableFetchTracking: false,
    },
  });
  appInsights.loadAppInsights();

  cached = { reactPlugin, appInsights };
  return cached;
}

export function getAppInsights(): AppTelemetry | null {
  return cached;
}
